<template>
    <div class="order_group">
        <tr>
            <td class="cursor_pointer" @click="toggleShow()">
                <i v-if="!show_info" class="fa fa-plus-circle"></i>
                <i v-else class="fa fa-minus-circle"></i>
            </td>
            <td>{{order.anyo+'/'+order.numero}}</td>
            <td>{{order.semana}}</td>
            <td>{{order.importe_envio}} €</td>
            <!--<td>{{order.subtotal}} €</td>
            <td>-{{order.ahorro}} €</td>-->
            <td>{{order.base_imponible}} €</td>
            <td>{{order.iva}} €</td>
            <td>{{order.recargo_equivalencia}} €</td>
            <td>{{order.precio_total}} €</td>
            <td v-if="!order.cancelado">
                <a v-if="order.check_factura" :href="route('account.pdf.pedidos',order.id)" class="btn-download" title="Descargar factura">
                    <i class="fa fa-download"></i>
                </a>
                <a v-if="order.estado_envio=='Pendiente'&&!order.check_factura" @click="cancelOrder()" class="btn-cancel cursor_pointer" title="Cancelar pedido">
                    <i class="fas fa-ban"></i>
                </a>
                <a v-if="order.estado_envio=='Pendiente'&&!order.check_factura" :href="route('account.pedidos.editar',order)" class="btn-edit cursor_pointer" title="Editar pedido">
                    <i class="fas fa-edit"></i>
                </a>
                <a v-if="order.avaiableCertificado" :href="route('download.certificado.eco')" class="btn-download green" title="Descargar certificado">
                    <span>ECO</span>
                    <i class="fa fa-download"></i>
                </a>
                <a v-if="order.need_pay" :href="route('account.pedidos.pagar',order)" class="btn-download green" title="Ir a pagar">
                    <i class="fa fa-money-bill-wave-alt"></i>
                </a>
            </td>
            <td v-else>
                Cancelado
            </td>
        </tr>
        <div v-if="show_info" class="order_block">
            <tr>
                <td colspan="13">
                    <table class="details">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Variedad</th>
                            <th>Nº bandejas</th>
                            <th>Formatos<br/>bandeja</th>
                            <th>ECO</th>
                            <th>Importe</th>
                            <th>Descuento</th>
                            <th>Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(line, index) in order.lineas" :key="index">
                            <td>{{index+1}}</td>
                            <td>{{ line.ecologico ? "ECO " : ""}}{{line.articulo.especie_verify.nombre}} {{line.articulo.nombre_verify}}
                                <img src="/img/logos/Logo-Euro-Agricultura.png" alt="Logo ECO" style="width: 20px"  v-if="line.ecologico" title="Producto ecológico">
                            </td>
                            <td><span style="white-space: nowrap">{{line.unidades}}</span></td>
                            <td><span style="white-space: nowrap">{{line.bandeja.nombre}}x{{line.semilla_alveolo}}</span></td>
                            <td v-if="line.ecologico" style="color:green;"><i class="fa fa-check-circle"></i></td>
                            <td v-else style="color:red;"><i class="fa fa-times-circle"></i></td>
                            <td><span style="white-space: nowrap">{{line.importe}} €</span></td>
                            <td><span style="white-space: nowrap">-{{line.ahorro}} €</span></td>
                            <td><span style="white-space: nowrap">{{line.total}} €</span></td>
                        </tr>
                        <tr v-for="(line, index) in order.lineas_medida" :key="index">
                            <td>{{ order.lineas.length + index+1}}</td>
                            <td>{{ line.ecologico ? "ECO " : ""}}{{line.variety.mote.especie.nombre}} {{line.variety.nombre}}
                                <img src="/img/logos/Logo-Euro-Agricultura.png" alt="Logo ECO" style="width: 20px"  v-if="line.ecologico" title="Producto ecológico">
                            </td>
                            <td><span style="white-space: nowrap">{{line.unidades}}</span></td>
                            <td><span style="white-space: nowrap">{{line.bandeja.nombre}}x{{line.semilla_alveolo}}</span></td>
                            <td v-if="line.ecologico" style="color:green;"><i class="fa fa-check-circle"></i></td>
                            <td v-else style="color:red;"><i class="fa fa-times-circle"></i></td>
                            <td><span style="white-space: nowrap">{{line.importe}} €</span></td>
                            <td><span style="white-space: nowrap">-{{line.ahorro}} €</span></td>
                            <td><span style="white-space: nowrap">{{line.total}} €</span></td>
                        </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['order'],
        data() {
            return {
                'show_info': false
            }
        },
        mounted: function () {
            /*for (var i=0;i<this.order.lineas.length;i++) {
                this.unidades += this.order.lineas[i].unidades;
            }*/
        },
        methods: {
            toggleShow: function () {
                this.show_info = !this.show_info;
            },
            cancelOrder: function() {
                confirm('¿Estas seguro que deseas cancelar el pedido?, Este proceso no se puede revertir.');

                axios.post(this.route('account.pedidos.cancel'), {
                    pedido_id: this.order.id,
                }).then(response => {
                    this.$parent.$emit('loadOrdersClient');
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                }).catch(e => {
                    Vue.toasted.show(e.response.data.info ? e.response.data.info : 'Ha habido un error!', {
                        type: "error",
                        duration: 3000
                    });
                    console.log(e);
                });

            }
        }
    }
</script>
